export enum HonorificEnum {
    "Mr" = "Mr",
    "Mrs" = "Mrs",
    "Dr" = "Dr",
    "Other" = "Other"
}

export enum GenderEnum {
    "Male" = "Male",
    "Female" = "Female",
    "Other" = "Other"
}

export enum MaritalStatusEnum {
    Single = "Single",
    Married = "Married",
    Widowed = "Widowed",
    Divorced = "Divorced",
    Separated = "Separated",
    RegisteredPartnership = "Registered Partnership"
}

export enum RaceEnum {
    "American Indian / Alaska Native" = "American Indian / Alaska Native",
    "Asian" = "Asian",
    "Black / African American" = "Black / African American",
    "Hispanic / Latino" = "Hispanic / Latino",
    "Native Hawaiian / Pacific Islander" = "Native Hawaiian / Pacific Islander",
    "White" = "White",
    "Other" = "Other"
}